import React, { useState, useEffect } from "react";
import Hero from "../components/Hero";
import ProductShowcase from "../components/ProductShowCase";
import AboutUs from "../components/AboutUs";
import Loading from "../components/Loading";
import NewsLetter from "../components/NewsLetter";
import Navbar from "../components/Navbar"
import Collections from "../components/Collections";

const HomeScreen = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading (or wait for data fetch)
    const timer = setTimeout(() => setLoading(false), 1000); // 1s delay
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Loading />;

  return (
    <>
    <Navbar/>
      <Hero />
      <AboutUs />
      <Collections/>
      <ProductShowcase />
      <NewsLetter/>

    </>
  );
};

export default HomeScreen;
